export default __webpack_public_path__ + "static/media/icon-alert.57c4a44a.svg";